import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IUserSettingsAddProjectPathBodyDataInput, IUserSettingsAddProjectPathResponse } from '../../../../interface/interfaces';

interface IInitialState {
    userSettingsAddProjectPathLoading: boolean;
    userSettingsAddProjectPathData: IUserSettingsAddProjectPathResponse | null;
    userSettingsAddProjectPathError: string;
}


const initialState: IInitialState = {
    userSettingsAddProjectPathLoading: false,
    userSettingsAddProjectPathData: null,
    userSettingsAddProjectPathError: '',
};

const userSettingsAddProjectPathSlice = createSlice({
    name: 'userSettingsAddProjectPath',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchUserSettingsAddProjectPathPending: (state: IInitialState, action: PayloadAction<IUserSettingsAddProjectPathBodyDataInput>) => {
            state.userSettingsAddProjectPathLoading = true;
            state.userSettingsAddProjectPathData = null;
            state.userSettingsAddProjectPathError = '';
        },

        fetchUserSettingsAddProjectPathFulfilled: (state: IInitialState, action: PayloadAction<IUserSettingsAddProjectPathResponse>) => {
            state.userSettingsAddProjectPathLoading = false;
            state.userSettingsAddProjectPathData = action.payload;
            state.userSettingsAddProjectPathError = '';
        },

        fetchUserSettingsAddProjectPathFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.userSettingsAddProjectPathLoading = false;
            state.userSettingsAddProjectPathData = null;
            state.userSettingsAddProjectPathError = action.payload;
        },
    },
});

export default userSettingsAddProjectPathSlice.reducer;
export const { fetchUserSettingsAddProjectPathPending, fetchUserSettingsAddProjectPathFulfilled, fetchUserSettingsAddProjectPathFailure } = userSettingsAddProjectPathSlice.actions;
